// ─────────────────────────────────────────────────────────────────────────────
// src/constants/modules.ts
//
// Single source of truth for:
//  • Module names
//
// ⚠️  DO NOT inline these strings directly in components.
//     Import from here so any rename is a one-line change.
// ─────────────────────────────────────────────────────────────────────────────

export const MODULES = {
  ADMIN: 'ADMIN',
  ATTENDANCE: 'ATTENDANCE',
  CLIENT: 'CLIENT',
  DEPARTMENT: 'DEPARTMENT',
  DESIGNATION: 'DESIGNATION',
  EMPLOYEE: 'EMPLOYEE',
  LEAVE: 'LEAVE',
  PAYROLL: 'PAYROLL',
  PERFORMANCE: 'PERFORMANCE',
  PERMISSION: 'PERMISSION',
  PROJECT: 'PROJECT',
  QUOTATION: 'QUOTATION',
  RECRUITMENT: 'RECRUITMENT',
  REIMBURSEMENT: 'REIMBURSEMENT',
  ROLE: 'ROLE',
  SHIFT: 'SHIFT',
  SYSTEM: 'SYSTEM',
  TIMESHEET: 'TIMESHEET',
  TRAINING: 'TRAINING',
  WORKER_TYPE: 'WORKER_TYPE',
} as const;

export type ModuleName = typeof MODULES[keyof typeof MODULES];
